export const PHONE = "+91 9999377037";
export const PHONE_TEL = "tel:+919999377037";
export const WA_NUMBER = "919999377037";
export const ADDRESS = "2185A, Tower E, Alphathum Bhutrani, Noida, Uttar Pradesh, India";
export const DEFAULT_WA_MSG =
  "Hello Pratap Group, I am interested in your website designing services. Please share details and pricing.";

export const waLink = (msg = DEFAULT_WA_MSG) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "portfolio", label: "Portfolio" },
  { id: "pricing", label: "Packages" },
  { id: "process", label: "Process" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
